/**
 * description: 接口入参加密/出参解密
 * created by yigeng on 2019/10/25
 */
/* eslint-disable */
import securityConfig from '../config/security.config';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import BetterStrorage from './betterStorage.service';
const RSA_PRVKEY_PEM = securityConfig.RSA_PRVKEY_PEM;
const RSA_PRVKEY_NO = securityConfig.RSA_PRVKEY_NO;
const BASE_URL = securityConfig.BASE_URL;
const betterStorage = new BetterStrorage();
class SecurityService {
  constructor() {}

  /**
   * 获取sessionId 和 AES密钥
   * @returns {Promise<any>}
   * @private
   */
  getParams() {
    return new Promise(async (resolve, reject) => {
      try {
        const sessionId = betterStorage.get('sessionId');
        const AESKeyCiphertext = betterStorage.get('AESKeyCiphertext');
        if (!sessionId || !AESKeyCiphertext) {
          const timestamp = +new Date();
          const { data } = await axios.get(
            `${BASE_URL}/msscy/client/hello/${timestamp}`
          );
          if (data.result === '000000') {
            resolve({
              sessionId: data.α,
              AESKeyCiphertext: data.β
            });
            betterStorage.set('sessionId', data.α, 30 * 60 * 1000);
            betterStorage.set('AESKeyCiphertext', data.β, 30 * 60 * 1000);
          } else {
            reject(false);
          }
        } else {
          resolve({
            sessionId: sessionId,
            AESKeyCiphertext: AESKeyCiphertext
          });
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  /**
   * 解密AES 所用的key
   * @param prvkey
   * @returns {PromiseLike<ArrayBuffer>}
   * @private
   */
  async _decryptAESkey() {
    const params = await this.getParams();
    const AESKey_ciphertext = params.AESKeyCiphertext;
    const prvRSAKey = KEYUTIL.getKey(RSA_PRVKEY_PEM);
    const hex = b64nltohex(AESKey_ciphertext);
    let AESKey = KJUR.crypto.Cipher.decrypt(hex, prvRSAKey, 'RSA');
    AESKey = CryptoJS.enc.Base64.parse(AESKey);
    return AESKey;
  }
  // async _decryptNO() {
  //   const params = await this.getParams();
  //   console.log('^^^^^^^^^^^',params);
  //   const AESKey_ciphertext = params.AESKeyCiphertext;
  //   const prvRSAKey = KEYUTIL.getKey(RSA_PRVKEY_NO);
  //   const hex = b64nltohex(AESKey_ciphertext);
  //   console.log('**************',prvRSAKey,hex);
  //   let AESKey = KJUR.crypto.Cipher.decrypt(hex, prvRSAKey, 'RSA');
  //   AESKey = CryptoJS.enc.Base64.parse(AESKey);
  //   return AESKey;
  // }
  /**
   * 身份证(字符串)明文加密
   * @data data
   * @returns {PromiseLike<ArrayBuffer>}
   * @private
   */
   async encryptAESkey(data){
    // const SECRET_KEY = CryptoJS.enc.Utf8.parse(RSA_PRVKEY_NO);
   const dataHex = CryptoJS.enc.Utf8.parse(data);
   const encrypted = CryptoJS.AES.encrypt(dataHex, RSA_PRVKEY_NO, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }); 
    return encrypted.ciphertext.toString();
  }
  // async encryptAESkey(data){
  //   // const SECRET_KEY = CryptoJS.enc.Utf8.parse(RSA_PRVKEY_NO);
  //  const dataHex = CryptoJS.enc.Utf8.parse(data);
  //  const AESKey = await this._decryptNO();
  // //  console.log('encryptAESkey---',dataHex,AESKey);
  //  const encrypted = CryptoJS.AES.encrypt(data, AESKey, {
  //     mode: CryptoJS.mode.CBC,
  //     padding: CryptoJS.pad.Pkcs7
  //   }); 
  //   return encrypted.toString();
  // }

//  jieme(data) {
//    console.log('使用解密',data);
//     let decrypted = CryptoJS.AES.decrypt(data, RSA_PRVKEY_NO, {
//       mode: CryptoJS.mode.ECB,
//       padding: CryptoJS.pad.Pkcs7
//     });
//     // 转换为 utf8 字符串
//     decrypted = CryptoJS.enc.Utf8.parse(decrypted);
//     return decrypted;
//   }
  /**
   * 明文加密
   * @param params
   * @returns {PromiseLike<ArrayBuffer>}
   * @private
   */
  async AESEncrypt(params) {
    params.timestamp = +new Date();
    const paramsStr = JSON.stringify(params);
    const AESKey = await this._decryptAESkey();
    let encrypted = CryptoJS.AES.encrypt(paramsStr, AESKey, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    encrypted = encrypted.toString();
    return encrypted;
  }

  /**
   * 密文解密
   * @param params
   * @returns {*}
   * @private
   */
  async AESDecrypt(params) {
    const AESKey = await this._decryptAESkey();
    let decrypted = CryptoJS.AES.decrypt(params, AESKey, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
    // 转换为 utf8 字符串
    decrypted = CryptoJS.enc.Utf8.stringify(decrypted);
    return JSON.parse(decrypted);
  }
}

export default SecurityService;
